import { request } from '@/utils/request'
import { APP_ROLE_DISPATCH } from '@/constants/appRole'

/** 获取当前登录用户基本信息 */
export function getUserInfo() {
  return request({
    url: '/member/user/get',
    method: 'GET'
  })
}

/** 修改用户基本信息（昵称、头像等） */
export function updateUser(data) {
  return request({
    url: '/member/user/update',
    method: 'PUT',
    data
  })
}

/** 忘记密码 - 重置密码（scene=4 验证码） */
export function resetPassword(mobile, code, password, appRole = APP_ROLE_DISPATCH) {
  return request({
    url: '/member/user/reset-password',
    method: 'PUT',
    data: {
      mobile,
      code,
      password,
      appRole
    }
  })
}
